import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["classNames", "messageClassNames", "messageTranslations", "messages", "messageComponent", "loaderComponent", "errorComponent", "actionsComponent", "tools", "indexUiState", "setIndexUiState", "status", "hideScrollToBottom", "onReload", "onClose", "translations", "userMessageProps", "assistantMessageProps", "isClearing", "onClearTransitionEnd", "isScrollAtBottom", "scrollRef", "contentRef", "onScrollToBottom"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cx } from "../../lib/index.js";
import { createButtonComponent } from "../Button.js";
import { createChatMessageComponent } from "./ChatMessage.js";
import { createChatMessageErrorComponent } from "./ChatMessageError.js";
import { createChatMessageLoaderComponent } from "./ChatMessageLoader.js";
import { ChevronDownIconComponent, CopyIconComponent, ReloadIconComponent } from "./icons.js";
var getTextContent = function getTextContent(message) {
  return message.parts.map(function (part) {
    return 'text' in part ? part.text : '';
  }).join('');
};
var hasTextContent = function hasTextContent(message) {
  return getTextContent(message).trim() !== '';
};
var copyToClipboard = function copyToClipboard(message) {
  navigator.clipboard.writeText(getTextContent(message));
};
function createDefaultMessageComponent(_ref) {
  var createElement = _ref.createElement,
    Fragment = _ref.Fragment;
  var ChatMessage = createChatMessageComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  return function DefaultMessage(_ref2) {
    var message = _ref2.message,
      userMessageProps = _ref2.userMessageProps,
      assistantMessageProps = _ref2.assistantMessageProps,
      tools = _ref2.tools,
      indexUiState = _ref2.indexUiState,
      setIndexUiState = _ref2.setIndexUiState,
      onReload = _ref2.onReload,
      onClose = _ref2.onClose,
      actionsComponent = _ref2.actionsComponent,
      classNames = _ref2.classNames,
      messageTranslations = _ref2.messageTranslations,
      translations = _ref2.translations;
    var defaultAssistantActions = [].concat(_toConsumableArray(hasTextContent(message) ? [{
      title: translations.copyToClipboardLabel,
      icon: function icon() {
        return createElement(CopyIconComponent, {
          createElement: createElement
        });
      },
      onClick: copyToClipboard
    }] : []), [{
      title: translations.regenerateLabel,
      icon: function icon() {
        return createElement(ReloadIconComponent, {
          createElement: createElement
        });
      },
      onClick: function onClick(m) {
        return onReload(m.id);
      }
    }]);
    var messageProps = message.role === 'user' ? userMessageProps : assistantMessageProps;
    var defaultActions = message.role === 'user' ? undefined : defaultAssistantActions;
    return createElement(ChatMessage, _extends({
      side: message.role === 'user' ? 'right' : 'left',
      variant: message.role === 'user' ? 'neutral' : 'subtle',
      message: message,
      tools: tools,
      indexUiState: indexUiState,
      setIndexUiState: setIndexUiState,
      onClose: onClose,
      actions: defaultActions,
      actionsComponent: actionsComponent,
      "data-role": message.role,
      classNames: classNames,
      translations: messageTranslations
    }, messageProps));
  };
}
export function createChatMessagesComponent(_ref3) {
  var createElement = _ref3.createElement,
    Fragment = _ref3.Fragment;
  var Button = createButtonComponent({
    createElement: createElement
  });
  var DefaultMessageComponent = createDefaultMessageComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  var DefaultLoaderComponent = createChatMessageLoaderComponent({
    createElement: createElement
  });
  var DefaultErrorComponent = createChatMessageErrorComponent({
    createElement: createElement
  });
  return function ChatMessages(userProps) {
    var _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      _userProps$messageCla = userProps.messageClassNames,
      messageClassNames = _userProps$messageCla === void 0 ? {} : _userProps$messageCla,
      messageTranslations = userProps.messageTranslations,
      _userProps$messages = userProps.messages,
      messages = _userProps$messages === void 0 ? [] : _userProps$messages,
      MessageComponent = userProps.messageComponent,
      LoaderComponent = userProps.loaderComponent,
      ErrorComponent = userProps.errorComponent,
      ActionsComponent = userProps.actionsComponent,
      tools = userProps.tools,
      indexUiState = userProps.indexUiState,
      setIndexUiState = userProps.setIndexUiState,
      _userProps$status = userProps.status,
      status = _userProps$status === void 0 ? 'ready' : _userProps$status,
      _userProps$hideScroll = userProps.hideScrollToBottom,
      hideScrollToBottom = _userProps$hideScroll === void 0 ? false : _userProps$hideScroll,
      onReload = userProps.onReload,
      onClose = userProps.onClose,
      userTranslations = userProps.translations,
      userMessageProps = userProps.userMessageProps,
      assistantMessageProps = userProps.assistantMessageProps,
      _userProps$isClearing = userProps.isClearing,
      isClearing = _userProps$isClearing === void 0 ? false : _userProps$isClearing,
      onClearTransitionEnd = userProps.onClearTransitionEnd,
      isScrollAtBottom = userProps.isScrollAtBottom,
      scrollRef = userProps.scrollRef,
      contentRef = userProps.contentRef,
      onScrollToBottom = userProps.onScrollToBottom,
      props = _objectWithoutProperties(userProps, _excluded);
    var translations = _objectSpread({
      scrollToBottomLabel: 'Scroll to bottom',
      copyToClipboardLabel: 'Copy to clipboard',
      regenerateLabel: 'Regenerate'
    }, userTranslations);
    var cssClasses = {
      root: cx('ais-ChatMessages', classNames.root),
      scroll: cx('ais-ChatMessages-scroll ais-Scrollbar', classNames.scroll),
      content: cx('ais-ChatMessages-content', classNames.content),
      scrollToBottom: cx('ais-ChatMessages-scrollToBottom', classNames.scrollToBottom),
      scrollToBottomHidden: cx('ais-ChatMessages-scrollToBottom--hidden', classNames.scrollToBottomHidden)
    };
    var DefaultMessage = MessageComponent || DefaultMessageComponent;
    var DefaultLoader = LoaderComponent || DefaultLoaderComponent;
    var DefaultError = ErrorComponent || DefaultErrorComponent;
    return createElement("div", _extends({}, props, {
      className: cx(cssClasses.root, props.className),
      role: "log",
      "aria-live": "polite"
    }), createElement("div", {
      className: cx(cssClasses.scroll),
      ref: scrollRef
    }, createElement("div", {
      className: cx(cssClasses.content, isClearing && 'ais-ChatMessages-content--clearing'),
      ref: contentRef,
      onTransitionEnd: function onTransitionEnd(e) {
        if (e.target === e.currentTarget && e.propertyName === 'opacity' && isClearing) {
          onClearTransitionEnd === null || onClearTransitionEnd === void 0 ? void 0 : onClearTransitionEnd();
        }
      }
    }, messages.map(function (message) {
      return createElement(DefaultMessage, {
        key: message.id,
        message: message,
        userMessageProps: userMessageProps,
        assistantMessageProps: assistantMessageProps,
        tools: tools,
        indexUiState: indexUiState,
        setIndexUiState: setIndexUiState,
        onReload: onReload,
        actionsComponent: ActionsComponent,
        onClose: onClose,
        translations: translations,
        classNames: messageClassNames,
        messageTranslations: messageTranslations
      });
    }), status === 'submitted' && createElement(DefaultLoader, {
      translations: {
        loaderText: translations.loaderText
      }
    }), status === 'error' && createElement(DefaultError, {
      onReload: onReload
    }))), createElement(Button, {
      variant: "outline",
      size: "sm",
      iconOnly: true,
      className: cx(cssClasses.scrollToBottom, (hideScrollToBottom || isScrollAtBottom) && cssClasses.scrollToBottomHidden),
      onClick: onScrollToBottom,
      "aria-label": translations.scrollToBottomLabel,
      tabIndex: isScrollAtBottom ? -1 : 0
    }, createElement(ChevronDownIconComponent, {
      createElement: createElement
    })));
  };
}